
import {$Wrap} from './Wrap';
import {Parallel} from './Parallel';
import {Sequence} from './Sequence';
import {Visibility} from './Visibility';
import {Alpha} from './Alpha';
import {Delay} from './Delay';
import {Tween} from './Tween';
import {Trigger} from './Trigger';

export * from './Wrap';

export const $Init = {
    Wrap: $Wrap,
    Parallel,
    Sequence,
    Visibility,
    Alpha,
    Delay,
    Tween,
    Trigger,
} as const;